<template>
	<div class="main_page">
		<div v-if="$root.error">
			<h1>Документы не найдены.</h1>
		</div>
		<div v-else>
			<h1>Документы № {{ $root.contract.number }}</h1>
			<h2>{{ $root.sublicentiate.short_name }}</h2>
			<div style="width:40%;">
				<router-link :to="'/documents/invoice/'+$route.params.id" class="link_style">Счёт</router-link> |
				<router-link :to="'/documents/contract/'+$route.params.id" class="link_style">Договор</router-link><span v-if="$root.user.supervisor">| </span> 
				<router-link v-if="$root.user.supervisor" :to="'/documents/act/'+$route.params.id"  class="link_style">Акт</router-link>
			</div>
			<div class="spcf_table">
				<table class="table table-bordered" cellpadding="6">
					<tbody>
						<tr>
							<th>№ п.п.</th>
							<th>Наименование</th>
							<th>Единица измерения</th>
							<th>Количество лицензий</th>
							<th>Цена, руб.</th>
							<td><b>Сумма(без НДС)</b><br></td>
						</tr>
						<tr v-for="item, index in $root.products">
							<td>{{ index+1 }}</td>
							<td>{{ item.full_name }} сроком на {{ item.license_period }} месяцев.</td>
							<td>шт.</td>
							<td>{{ item.license_count }}</td>
							<td>{{ item.license_price }}</td>
							<td>{{ item.license_total_sum }}</td>
						</tr>
						<tr>
							<td></td>
							<th colspan="4">Итого:</th>
							<th>{{ $root.contract.total_sum  }}</th>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	mounted(){
	  // if(!Object.keys(this.$root.licentiate).length){
	  //   this.$root.get_invoice_data();
	  // }
	  document.title = "Документы"
	  if(this.$route.params.id != this.$root.invoice_id){
		   this.$root.get_invoice_data();
	  }
	}
}
</script>

<style>
	.link_style{
		text-decoration: none;
		 font-size: 16px;
	}
</style>